<div class="auth-full-height container d-flex flex-column justify-content-center" style="background-image: url('assets/images/others/bg-1.jpg');">
    <div class="row justify-content-center">
        <div class="col-md-8">
            <div class="card row mx-0 flex-row overflow-hidden">
                <div class="col-md-4 bg-size-cover d-flex align-items-center p-4" style="background-image: url('assets/images/others/bg-4.jpg');">
                    <div>
                        <div class="mb-5">
                            <!-- <logo [white]="true" [height]="50"></logo> -->
                        </div>
                        <div class="nav-logo">
                            <img src="assets/images/logo/logo.png" width="170px">
                        </div>
                        <p class="text-white mt-4 mb-5 o-75"></p>
                    </div>
                </div>
                <div class="col-md-8 px-0">
                    <div class="card-body">
                        <div class="my-5 mx-auto" style="max-width: 350px;">
                            <div class="mb-3">
                                <h3>Login</h3>
                            </div>
  <!-- <loginForm></loginForm> -->
  <div class="alert alert-danger" *ngIf="showResult">

  </div>
  <form [formGroup]="addLoginForm" (ngSubmit)="login()">
      <div class="form-group mb-3">
          <label class="form-label">Username</label>
          <input 
              type="text" 
              class="form-control no-validation-icon no-success-validation" 
              formControlName="email"
          >
      </div>
      <div class="mb-3 ">
          <label class="form-label d-flex justify-content-between">
              <span>Password</span>
              <a class="text-primary font" href="">Forgot Password?</a>
          </label>
          <div class="form-group input-affix flex-column">
              <label class="d-none">Password</label>
              <input 
                  [type]="showPassword ? 'text' : 'password'" 
                  class="form-control no-validation-icon no-success-validation" 
                  formControlName="password"
              >
              <i 
                  class="suffix-icon feather cursor-pointer text-dark"     
                  [ngClass]="showPassword ? 'icon-eye-off' : 'icon-eye'" 
                  (click)="onShowPasswordClick()"
              >
              </i>
          </div>
      </div>
      <button class="btn btn-primary w-100" type="submit">Log In</button>
  </form>
  <!-- <div *ngIf="thirPartyLogin">
      <div class="divider">
          <span class="divider-text text-muted">or login with</span>
      </div>
      <div class="row">
          <div class="col px-1">
              <button class="btn btn-outline-secondary w-100">
                  <img src="assets/images/thumbs/thumb-1.png" alt="" style="max-width: 20px;">
              </button>
          </div>
          <div class="col px-1">
              <button class="btn btn-outline-secondary w-100">
                  <img src="assets/images/thumbs/thumb-2.png" alt="" style="max-width: 20px;">
              </button>
          </div>
          <div class="col px-1">
              <button class="btn btn-outline-secondary w-100">
                  <img src="assets/images/thumbs/thumb-3.png" alt="" style="max-width: 20px;">
              </button>
          </div>
      </div>
  </div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>